import React from "react";
import { useQuery } from "react-query";

import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
} from "@material-ui/core";

import styled from "styled-components/macro";

import Table from "../../../components/Table";
import { spacing } from "@material-ui/system";
import Panel from "../../../components/panels/Panel";
import Link from "@material-ui/core/Link";
import { NavLink } from "react-router-dom";

import { Helmet } from "react-helmet-async";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import parse from "html-react-parser";

const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(12)}px);
  max-height: calc(100% - 48px);
`;

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

//388px
const AllWellsReport = () => {
  const { getAccessTokenSilently } = useAuth0();

  const { data, isFetching, error } = useQuery(
    ["ui-report-all-wells-for-download"],
    async () => {
      try {
        const token = await getAccessTokenSilently();
        const headers = { Authorization: `Bearer ${token}` };

        const { data } = await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/ui-report-all-wells-for-download`,
          { headers }
        );
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );

  if (error) return "An error has occurred: " + error.message;

  const tabColumns = [
    {
      title: "CUWCD Well Number",
      field: "cuwcd_well_number",
    },
    {
      title: "State Well Number",
      field: "state_well_number",
    },
    {
      title: "Well Name",
      field: "well_name",
    },
    {
      title: "Owner",
      field: "well_owner",
    },
    {
      title: "Is Exempt?",
      field: "exempt",
      type: "boolean",
    },
    {
      title: "Management Zone",
      field: "management_zone",
    },
    {
      title: "TX Grid",
      field: "texas_grid_id",
    },
    {
      title: "Aquifer",
      field: "aquifer_name",
    },
    {
      title: "Well Status",
      field: "well_status_desc",
    },
    {
      title: "Primary Use",
      field: "primary_use",
    },
    {
      title: "Secondary Use",
      field: "secondary_use",
    },
    {
      title: "Has Production?",
      field: "has_production",
      type: "boolean",
    },
    {
      title: "Longitude",
      field: "longitude_dd",
    },
    {
      title: "Latitude",
      field: "latitude_dd",
    },
    {
      title: "Elevation (ft msl)",
      field: "elevation_ftabmsl",
    },
    {
      title: "Well Depth (ft)",
      field: "well_depth_ft",
    },
    {
      title: "Screen Top Depth (ft)",
      field: "screen_top_depth_ft",
    },
    {
      title: "Screen Bottom Depth (ft)",
      field: "screen_bottom_depth_ft",
    },
    {
      title: "Driller",
      field: "driller",
    },
    {
      title: "Date Drilled",
      field: "date_drilled",
      type: "date",
    },
    {
      title: "Drillers Log?",
      field: "drillers_log",
      type: "boolean",
    },
    {
      title: "Owner Address",
      field: "well_owner_address",
      cellStyle: {
        width: 300,
        minWidth: 300,
      },
    },
    {
      title: "Notes",
      field: "notes",
      cellStyle: {
        width: 300,
        minWidth: 300,
      },
    },
    {
      title: "Attachments",
      field: "list_of_attachments",
      render: (rowData) => {
        return rowData?.list_of_attachments
          ? rowData?.list_of_attachments
              .split(",")
              .map((item) => <li key={item}>{parse(item)}</li>)
          : "";
      },
      cellStyle: {
        width: 600,
        minWidth: 600,
      },
    },
  ];

  return (
    <>
      <Helmet title="Wells Search Report" />
      <Typography variant="h3" gutterBottom display="inline">
        Wells Search Report
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/dashboard">
          Dashboard
        </Link>
        <Typography>Wells Search</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <Panel>
        <TableWrapper>
          <Table
            options={{ filtering: true }}
            label="Wells Search Report"
            isLoading={isFetching}
            columns={tabColumns}
            data={data}
            height="600px"
          />
        </TableWrapper>
      </Panel>
    </>
  );
};

export default AllWellsReport;
